import React from 'react';
import { Link } from 'react-router-dom';
import { contactInfo } from '../mockData';
import { FileText, Linkedin, X, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-notaria-primary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Copyright */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/r6mfwaxc_logo-light-notaria.png" 
                alt="Notaria 90" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-sm text-gray-300 mb-4">
              © Copyright Notaria 90 - Certeza Legal
            </p>
            <Link 
              to="/aviso-de-privacidad" 
              className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
            >
              <FileText className="w-4 h-4" />
              Aviso de Privacidad
            </Link>

            {/* Social Media Icons */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.instagram.com/notaria90playa" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.facebook.com/notaria90" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/notaria-publica-90" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://x.com/notaria90playa" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="X (Twitter)"
              >
                <X className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contáctanos</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p>
                <strong>Teléfonos:</strong> {contactInfo.phones.join(' / ')}
              </p>
              <p>
                <strong>Whatsapp:</strong> {contactInfo.whatsapp}
              </p>
              <p>
                <strong>Email:</strong>{' '}
                <a href={`mailto:${contactInfo.email}`} className="hover:text-cyan-300 transition-colors">
                  {contactInfo.email}
                </a>
              </p>
            </div>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-lg font-bold mb-4">Ubicanos</h4>
            <p className="text-sm text-gray-300">
              {contactInfo.address}
            </p>
          </div>
        </div>

        {/* Privacy Notice in footer bottom */}
        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <p className="text-xs text-gray-400">
            En cumplimiento a lo dispuesto en la Ley Federal de Protección de Datos Personales, 
            el Notario Público número Noventa informa que los datos obtenidos serán usados únicamente 
            para la presente operación y registro de servicios. {' '}
            <Link to="/aviso-de-privacidad" className="text-cyan-300 hover:text-white underline">
              Consulta nuestro Aviso de Privacidad completo
            </Link>
          </p>
          <Link
            to="/editor"
            className="inline-block mt-4 text-[11px] text-gray-500 hover:text-gray-300 transition-colors"
            data-testid="editor-access-link"
          >
            Acceso editor
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
